import axios, { buildApi } from "@/libs/api.request";

export const apis = buildApi({
  curd: '/finance/freight',

})
// 获取批量信息
export const getFreight = params => {
  return axios.request({
    url: "/finance/freight",
    method: "GET",
    params
  });
};
// 获取单个信息
export const getDetails = id => {
  return axios.request({
    url: `/finance/freight/${id}`,
    method: "GET"
  });
};
// 删除
export const del = id => {
  return axios.request({
    url: `/finance/freight/${id}`,
    method: "DELETE"
  });
};
// 修改
export const update = data => {
  return axios.request({
    url: `/finance/freight/${data.id}`,
    method: "PUT",
    data
  });
};
// 新增
export const add = data => {
  return axios.request({
    url: "/finance/freight",
    method: "POST",
    data
  });
};

// 新增
export const bindClient = params => {
  return axios.request({
    url: `/finance/freight/exportClient/${params.id}`,
    method: "get",
    params
  });
};

export const getRules = params => {
  return axios.request({
    url: `/finance/ddu/rule/getCountryRule/${params.country}`,
    method: "get",
    params
  });
}

export const Bind = data => {
  return axios.request({
    url: `/finance/freight/switchAutoBind/${data.id}`,
    method: "post",
    data
  });
}

export const setLabel = data => {
  return axios.request({
    url: `/finance/freight/saveGroupTag`,
    method: "post",
    data
  });
}

export const getDiscount = params => {
  return axios.request({
    url: "/quotation/discount/getList",
    method: "GET",
    params
  });
};

export const switchEnable = data => {
  return axios.request({
    url: `/finance/freight/switchEnable//${data.id}`,
    method: "post",
    data
  });
}

export const setTime = data => {
  return axios.request({
    url: `/finance/freight/setTime`,
    method: "post",
    data
  });
}

export const getFilterResult = params => {
  return axios.request({
    url: `/finance/freight/filter`,
    method: "post",
    params
  });
}
